module.exports = __webpack_public_path__ + "bh.no1.e67e635d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bh.no1.jpg
// module id = Yz02
// module chunks = 0